import { useFlashSale } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useFlashSale";
import { home } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { useIsRetailerCreatedWithinLast30Days } from "@faire/deprecated-retailer-visitor-shared/stores/ui/useIsRetailerCreatedWithinLast30Days";
import { HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22 } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useRetailerMilestone } from "@faire/web/common/hooks";
import { matchPath } from "react-router-dom";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useWarehouseSaleGate: IGateHook = () => {
  const modalType = useModalType();
  const { hasOccurred: hasSeenWarehouseSaleModal } = useRetailerMilestone(
    HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22
  );
  const { isRetailerCreatedWithinLast30Days } =
    useIsRetailerCreatedWithinLast30Days();
  const { showWarehouseFlashSale } = useFlashSale();

  if (
    showWarehouseFlashSale &&
    !isRetailerCreatedWithinLast30Days &&
    !!matchPath(getWindowOrThrow().location.pathname, {
      path: home(),
      exact: true,
    }) &&
    !hasSeenWarehouseSaleModal &&
    modalType === PromoModalType.WAREHOUSE_SALE_MODAL
  ) {
    return PromoModalType.WAREHOUSE_SALE_MODAL;
  }

  return undefined;
};
